export const  hasClass = (element, cls)=>(
    (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1
)

let headers = {'Content-type': 'application/json','accept': 'application/json'};

const host_port = window.location.host
let options = { 
  method: "POST",
  headers
}
if(host_port === 'localhost:3000'){
  options = { 
    method: "POST",
    headers
  }
}

export const post = (url, data) =>
	fetch(url, {...options,body: JSON.stringify(data)})
	.then(
        res => res.json(),
        (error) => {
           console.log.bind(console);
           return Promise.reject(error);
        }
   	);



// WEBPACK FOOTER //
// ./src/Utils/index.js